import * as React from "react"

import { Container, Row } from "./library/container"
import { trackCollectionSearch } from "./library/tracking"

export interface CollectionSearchBarProps {}

interface CollectionSearchBarState {
  input: string
}

export class CollectionSearchBar extends React.Component<CollectionSearchBarProps, CollectionSearchBarState> {
  constructor(props: CollectionSearchBarProps) {
    super(props)

    this.state = { input: "" }
  }

  render() {
    const s = this.state
    const p = this.props

    const search: () => void = () => {
      trackCollectionSearch(s.input)
      window.open(`https://probiblio.hostedwise.nl/wise-apps/opac/6190/catalog/search?qs=${s.input}`)
    }

    return (
      <form className="form form--search search">
        <div>
          <label htmlFor="collection-search" className="form__label">
            Wat wil je lezen, luisteren of kijken?<span className="sr-text">(externe link)</span>
          </label>
          <span className="form__input-placeholder">(Titel, auteur, onderwerp of ISBN)</span>
        </div>
        <div className="search__input-container">
          <input
            id="collection-search"
            className="form__input search__input"
            type="text"
            onChange={e => this.setState({ ...this.state, input: e.currentTarget.value })}
            value={s.input}
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => (e.key == "Enter" ? search() : {})}
            placeholder="Ik zoek..."
            autoComplete="on"
          />
          <button type="button" className="search__button" onClick={search}>
            <span className="sr-text">Zoeken</span>
            <span className="icon icon-search" aria-hidden="true" />
          </button>
        </div>
      </form>
    )
  }
}
